export const FETCH_CLAIMS_REQUEST = 'FETCH_CLAIMS_REQUEST';
export const FETCH_CLAIMS_SUCCESS = 'FETCH_CLAIMS_SUCCESS';
export const FETCH_CLAIMS_FAILURE = 'FETCH_CLAIMS_FAILURE';

export const FETCH_CHECK_CLAIMS_REQUEST = 'FETCH_CHECK_CLAIMS_REQUEST';
export const FETCH_CHECK_CLAIMS_SUCCESS = 'FETCH_CHECK_CLAIMS_SUCCESS';
export const FETCH_CHECK_CLAIMS_FAILURE = 'FETCH_CHECK_CLAIMS_FAILURE';

export const fetchClaimsRequest = (params = {}) => ({ type: FETCH_CLAIMS_REQUEST, payload: params });
export const fetchClaimsSuccess = (data) => ({ type: FETCH_CLAIMS_SUCCESS, payload: data });
export const fetchClaimsFailure = (error) => ({ type: FETCH_CLAIMS_FAILURE, payload: error });

export const fetchCheckClaimsRequest = (params = {}) => ({ type: FETCH_CHECK_CLAIMS_REQUEST, payload: params });
export const fetchCheckClaimsSuccess = (data) => ({ type: FETCH_CHECK_CLAIMS_SUCCESS, payload: data });
export const fetchCheckClaimsFailure = (error) => ({ type: FETCH_CHECK_CLAIMS_FAILURE, payload: error });




